export class ContactUsConstants {
    public static getContactUsUrl = 'retail-web/retail-account-requests/contactUs';
}
